import React from 'react'
import { useEffect } from 'react'
import { Form, Input, Button } from 'antd'
import { LockOutlined, UserOutlined } from '@ant-design/icons'
import ReCAPTCHA from 'react-google-recaptcha'
import { RECAPTCHA_SITE_KEY } from '../../firebase/firebase'
import './Login.css'
import vendedorLojaImg from '../../assets/login/vendedor-loja.jpg'
import { useHistory } from 'react-router-dom'
import { autenticar, redirectJustIfUserIsAuthenticated } from './LoginF'
import API from '../../services/api/api'

const api = new API()
const params = new URLSearchParams(window.location.search)

const Login = ({ }) => {
  const [loading, setLoading] = React.useState(false)
  const history = useHistory()
  const [reCaptchaToken, setReCaptchaToken] = React.useState(undefined)
  const [disableLogin, setDisableLogin] = React.useState(true)

  useEffect(() => {
    redirectJustIfUserIsAuthenticated(history)
  }, [])

  const onReCaptchaChange = token => {
    let disableLogin = token ? false : true
    setDisableLogin(disableLogin);
    setReCaptchaToken(token)
  }

  const handleFormFinish = async values => {
    setLoading(true)

    if (window.location.hostname !== 'localhost') {
      const reCaptchaIsOk = await api.validateReCaptcha(reCaptchaToken)

      if (!reCaptchaIsOk) {
        setLoading(false)
        setDisableLogin(true)
        this.warning('Falha no catpcha')
        return
      }
    }

    const userAuthenticated = await autenticar(values.login, values.password)

    // this.setState({ loading: false })
    setLoading(false)

    if (userAuthenticated) {
      history.push(`/fila`)
      history.go()
    }
  }

  const handleFinishFailed = ({ errorFields }) => {
    // this.props.form.scrollToField(errorFields[0].name);
  }

  return (
    <div className='login-root'>
      <div className='login-wrapper'>
        <div
          className='login-image-section'
          aria-label='Imagem ilustrativa de vendas e controle'
        >
          {/* Aqui pode trocar para qualquer imagem ou SVG que quiser */}
          <img
            src={vendedorLojaImg}
            alt='Controle de fila e vendas Bluve'
            className='login-image'
          />
        </div>

        <div className='login-form-section'>
          <img
            src='https://storage.googleapis.com/bluve-bucket/logo_oficial.png'
            alt='Logo Bluve'
            className='logo'
          />
          <h1 className='login-title'>Fila da Vez - Bluve</h1>
          <p className='login-subtitle'>
            Organize os atendimentos e entenda por que sua loja deixa de vender.
          </p>

          <Form
            name='login-form'
            className='login-form'
            onFinish={handleFormFinish}
            onFinishFailed={handleFinishFailed}
            layout='vertical'
            // <Form onFinish={this.handleFormFinish}  className="login-form">
          >
            <Form.Item
              name='login'
              rules={[{ required: true, message: 'Informe o login da loja' }]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder='Login da Loja'
                size='large'
                autoComplete='username'
              />
            </Form.Item>

            <Form.Item
              name='password'
              rules={[{ required: true, message: 'Informe a senha de login' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder='Senha'
                size='large'
                autoComplete='current-password'
              />
            </Form.Item>

            <Form.Item>
              <ReCAPTCHA
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={onReCaptchaChange}
              />
            </Form.Item>

            <Form.Item>
              <Button
                type='primary'
                htmlType='submit'
                className='login-button'
                size='large'
                loading={loading}
                disabled={disableLogin}
              >
                Entrar
              </Button>
            </Form.Item>

            <Form.Item>
              <button
                type='button'
                className='forgot-password'
                onClick={() =>
                  alert('Peça ao gestor para recuperar sua senha.')
                }
              >
                Esqueci minha senha
              </button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  )
}

export default Login
